const FIRM_BADGE_STATUSES = new Set([
  "Scheduled",
  "In_Production",
  "On_Hold",
  "QC",
]);

export function shouldShowFirmBadge(card = {}) {
  const status = String(card.status || "").trim();

  if (!FIRM_BADGE_STATUSES.has(status)) return false;
  if (card.isArchived || card.cancelled || card.disabled) return false;

  return Boolean(card.isFirm || card.is_firm);
}
